// La jauge du match : ce qu'une annonce vaut pour l'entreprise, de 0 à 100 (app/sourcing/match.py). Cinq barres
// empilées, allumées depuis le bas, du vert le plus clair au vert foncé : sous le seuil bas (hors fit), la seule du
// bas ; à partir du seuil haut, toutes ; entre les deux, deux à quatre. Le score est dans l'infobulle.

import type { Match, Seuils } from "@/lib/api";

// Les cinq niveaux, du plus pâle (n1, hors fit) au plus foncé (n5) : leurs teintes sont --fit-n1 … --fit-n5.
export const NIVEAUX = ["n1", "n2", "n3", "n4", "n5"] as const;
export type Niveau = (typeof NIVEAUX)[number];
const BARRES = [0, 1, 2, 3, 4];

export function teinte(score: number, seuils: Seuils): Niveau {
  if (score < seuils.bas) return "n1";
  if (score >= seuils.haut) return "n5";
  const t = (score - seuils.bas) / (seuils.haut - seuils.bas);
  return t < 1 / 3 ? "n2" : t < 2 / 3 ? "n3" : "n4";
}

export function Pile({
  match,
  seuils,
  raisons,
}: {
  match: Match | null | undefined;
  seuils: Seuils;
  raisons?: Record<string, string>;
}) {
  if (!match)
    return (
      <span
        className="pile pile-vide"
        title="Pas encore matchée"
        role="img"
        aria-label="Pas encore matchée"
      >
        {BARRES.map((i) => (
          <span key={i} />
        ))}
      </span>
    );
  const t = teinte(match.score, seuils);
  const allumees = NIVEAUX.indexOf(t) + 1;
  const pourquoi = Object.entries(match.raisons)
    .map(
      ([k, p]) =>
        `${raisons?.[k] ?? k} : ${p >= 0.6 ? "oui" : p <= 0.4 ? "non" : "peut-être"} (${Math.round(p * 100)} %)`,
    )
    .join("\n");
  return (
    <span
      className={`pile pile-${t}`}
      title={`Match ${match.score}/100 (confiance ${Math.round(match.confiance * 100)} %)\n${pourquoi}`}
      role="img"
      aria-label={`Match ${match.score} sur 100`}
    >
      {/* De haut en bas : la barre du haut ne s'allume qu'au seuil haut. */}
      {BARRES.map((i) => (
        <span key={i} className={5 - i <= allumees ? "allumee" : ""} />
      ))}
    </span>
  );
}
